class BunnyDate {
  public static getTimeLabel(
    dateInMillis: number,
    time_scale: 'day' | 'month' | string
  ) {
    if (time_scale === 'day') {
      return BunnyDate.getDate(dateInMillis);
    }
    if (time_scale === 'month') {
      return BunnyDate.getMonth(dateInMillis);
    }
    return '';
  }

  public static getDate(timeSinceEpoch: number) {
    const formatter = new Intl.DateTimeFormat('en', {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
    });
    const dateTime = new Date(0);
    dateTime.setUTCSeconds(timeSinceEpoch);
    return formatter.format(dateTime);
  }

  public static getMonth(timeSinceEpoch: number) {
    const formatter = new Intl.DateTimeFormat('en', { month: 'long' });
    const dateTime = new Date(0);
    dateTime.setUTCSeconds(timeSinceEpoch);
    return formatter.format(dateTime);
  }
}

export default BunnyDate;
